import HomeContainer from './containers/HomeContainer'

// Sync route definition
export default {
  component : HomeContainer
}



// WEBPACK FOOTER //
// ./src/routes/Home/index.js